import { render } from "./auth-base-password-recover.vue?vue&type=template&id=6a07dca2&scoped=true&ts=true"
import script from "./auth-base-password-recover.vue?vue&type=script&lang=ts"
export * from "./auth-base-password-recover.vue?vue&type=script&lang=ts"

import "./auth-base-password-recover.vue?vue&type=style&index=0&id=6a07dca2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a07dca2"]])

export default __exports__